export default __webpack_public_path__ + "svg/calendar/2025/7/octubre.svg?14276938";